<template>
  <form id="forgot-password" @submit.prevent="forgotPassword">
    <h1 class="title">Esqueci a senha</h1>
    <p class="subtitle">
    </p>

    <div class="alert -danger" v-if="errors.unrecognized">
      <p class="title">Ops!</p>

      <p>Ocorreu um erro ao tentar recuperar sua senha, tente novamente.</p>
    </div>

    <div class="alert -success" v-if="finished">
      <p>Foi enviado um link de recuperação para o e-mail informado.</p>
    </div>

    <div class="form-group" :class="{'-has-error': errors.form.email.length > 0}">
      <label for="email" class="label">E-mail</label>
      <input
        class="form-control"
        id="email"
        type="email"
        placeholder="Email"
        v-model="form.email"
        autocomplete
        required
      >
      <p class="description" v-if="errors.form.email.length > 0">{{ errors.form.email[0] }}</p>
    </div>

    <div class="actions">
      <button class="btn btn-primary -full-width" type="submit">
        Recuperar
      </button>
    </div>

    <div class="callLogin">
      <p>Sabe sua senha? <router-link to="/login">Faça login</router-link>.</p>
    </div>

    <loader
      background="#FFF"
      v-if="loading"/>
  </form>
</template>

<script>
import { mask } from 'vue-the-mask';
import Loader from '@/support/components/Loader.vue';
import checkErrorIsUnrecognizedResponse from '@/support/helpers/checkErrorIsUnrecognizedResponse';

export default {
  name: 'ForgotPassword',

  data() {
    return {
      form: {
        email: '',
      },

      finished: false,
      loading: false,

      errors: {
        unrecognized: false,
        form: {
          email: [],
        },
      },
    };
  },

  methods: {
    /**
     * Register the user.
     *
     * @returns {Promise<void>}
     */
    async forgotPassword() {
      try {
        this.loading = true;
        this.resetErrors();

        await this.$store.dispatch('auth/forgotPassword', this.form);

        this.resetFields();
        document.getElementById('forgot-password').reset();
        this.finished = true;
      } catch (err) {
        if (checkErrorIsUnrecognizedResponse(err, [422])) {
          this.errors.unrecognized = true;

          return;
        }

        const { data, status } = err.response;

        if (status === 422) {
          this.errors.form.email = data.errors.email || [];
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the errors page.
     */
    resetErrors() {
      this.errors.form.email = [];
      this.errors.unrecognized = false;
    },
    resetFields() {
      this.form.email = '';
    },
  },

  computed: {
  },

  directives: {
    mask,
  },

  components: {
    Loader,
  },
};
</script>

<style lang="scss" scoped>
  #forgot-password {
    @apply relative;

    > .alert {
      @apply mb-4;
    }

    > .title {
      @apply text-xl;
      @apply font-bold;
      @apply text-secondary-700;
      letter-spacing: -0.01em;
      margin-bottom: 8px;
    }

    > .subtitle {
      @apply text-sm;
      @apply mb-5;
      @apply text-gray-800;
    }

    > .form-group {
      @apply mb-5;
    }

    > .actions {
      @apply mb-5;
    }

    > .callLogin {
      @apply text-sm;
      @apply mb-5;
      @apply text-gray-800;
    }
  }
</style>
